/**
 * 处理树数据，删除children为空的
 */
function handleTreeList (list) {
    if (list.length <= 0) {
        return list
    }
    for (var i = 0; i < list.length; i++) {
        if (typeof (list[i].children) === 'undefined' || list[i].children.length < 1) {
            list[i].children = undefined
        } else {
            this.handleTreeList(list[i].children)
        }
    }
    return list
}

/**
 * 对象转数组
 * @param {} obj
 * @returns
 */
function convertObjectToArray (obj) {
    const arr = []
    Object.keys(obj).forEach(key => {
        arr[key] = obj[key]
    })
    return arr
}

/**
 * 根据code获取name值
 * @param {*} array
 * @param {*} code
 * @returns
 */
function getNameByCode (array, code) {
    const foundObject = array.find(item => item.code === code)
    return foundObject ? foundObject.name : ''
}

export default {
    handleTreeList,
    convertObjectToArray,
    getNameByCode
}
